import React from 'react'
import "./header.css"

function Header() {
  return (
    <div>
         <div className='headerline'>
            <img className='imgface' src='Logo (1).png'></img>
            <span className='span'>React Course-project-3</span>
         </div>
    </div>
  )
}

export default Header